import _ from "./design-system.es88.js";
import k from "./design-system.es345.js";
import x from "./design-system.es58.js";
import { resolveComponent as c, openBlock as i, createBlock as w, mergeProps as C, withCtx as p, createElementVNode as o, withDirectives as h, createVNode as u, vShow as P, createTextVNode as n, renderSlot as S, withModifiers as d, createElementBlock as l, createCommentVNode as a, toDisplayString as m } from "vue";
/* empty css                    */
import T from "./design-system.es128.js";
const b = {
  name: "DsGuideLegacy",
  components: {
    Popover: _,
    PulseGraphic: k,
    Icon: x
  },
  props: {
    /**
     * Title text
     */
    title: {
      type: String,
      default: ""
    },
    /**
     * Body text
     */
    bodyText: {
      type: String,
      default: ""
    },
    /**
     * Confirmation button text
     */
    confirmText: {
      type: String,
      required: !0
    },
    /**
     * Should visually display the guide
     */
    show: Boolean,
    /**
     * Should display an x in the upper right to close it out
     */
    hasClose: Boolean
  },
  emits: [
    "cancel",
    "confirm"
  ],
  methods: {
    cancel() {
      this.$emit("cancel");
    },
    confirm() {
      this.$emit("confirm");
    }
  }
}, B = { class: "reference" }, G = { class: "pulse-container" }, I = { class: "top" }, N = {
  key: 1,
  class: "guide-header"
}, V = {
  key: 2,
  class: "guide-body"
};
function D(f, e, t, q, E, r) {
  const v = c("PulseGraphic"), y = c("Icon"), g = c("Popover");
  return i(), w(g, C(f.$attrs, {
    legacy: "",
    "is-open": t.show,
    "hide-arrow": ""
  }), {
    reference: p(() => [
      o("div", B, [
        h(o("span", G, [
          u(v)
        ], 512), [
          [P, t.show]
        ]),
        e[3] || (e[3] = n()),
        S(f.$slots, "reference", {}, void 0, !0)
      ])
    ]),
    default: p(() => [
      e[7] || (e[7] = n()),
      o("div", {
        class: "popover-content",
        onClick: e[2] || (e[2] = d(() => {
        }, ["stop", "prevent"]))
      }, [
        o("section", I, [
          t.hasClose ? (i(), l("span", {
            key: 0,
            class: "close-container",
            onClick: e[0] || (e[0] = d((...s) => r.cancel && r.cancel(...s), ["stop", "prevent"]))
          }, [
            u(y, { name: "x" })
          ])) : a("", !0),
          e[4] || (e[4] = n()),
          t.title ? (i(), l("div", N, m(t.title), 1)) : a("", !0),
          e[5] || (e[5] = n()),
          t.bodyText ? (i(), l("div", V, m(t.bodyText), 1)) : a("", !0)
        ]),
        e[6] || (e[6] = n()),
        o("div", {
          class: "guide-footer",
          "data-qa": "guide-confirm-button",
          onClick: e[1] || (e[1] = d((...s) => r.confirm && r.confirm(...s), ["stop", "prevent"]))
        }, m(t.confirmText), 1)
      ])
    ]),
    _: 3
  }, 16, ["is-open"]);
}
const H = /* @__PURE__ */ T(b, [["render", D], ["__scopeId", "data-v-fda24e95"]]);
export {
  H as default
};
//# sourceMappingURL=design-system.es201.js.map
